import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { selectMatchState, setMatchState } from '../../../store/match';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
import { confirmPlayerVote } from '../../../api';
import maleAvatar from "../../../../public/img/man.png";
import femaleAvatar from "../../../../public/img/woman.png";
import dots from '../../../../public/img/vote-dots.png';
const votingStyle = {
    // padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    backgroundColor: 'transparent',
    boxShadow: '0',
    marginTop: '22px',
};
const VoteContainer = styled.div `
  background: radial-gradient(100.48% 122.16% at 99.03% 98.33%, #356166 14.37%, #2e4245 82.78%);
  box-shadow: 0px 21px 47px rgba(0, 0, 0, 0.31);
  border-radius: 24px;
  overflow: hidden;
  position: absolute;
  padding: 24px;
  top: 50%;
  transform: translateY(-50%);
  right: 146px;
  z-index: 100;
`;
const PlayerContainer = styled.div `
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
const PlayerImg = styled.img `
  width: 40px;
  height: 40px;
  border-radius: 50%;
  user-select: none;
  object-fit: cover;
`;
const PlayerNick = styled.div `
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
`;
const PlayerAction = styled.div `
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.8);
`;
const VotingPlayerAction = styled(PlayerAction) `
  color: #2ab2ff;
`;
const VoteContainerImage = styled.img `
  width: 76px;
  height: 63px;
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
`;
const DottedLine = styled.div `
  margin: 3px 0 3px 18px;
  width: 0px;
  height: 18px;
  border-left: 4px dotted black;
`;
const Image = styled.img `
  width: 4px;
  height: 24px;
  flex-shrink: 0;
  margin: 10px 0;
`;
const Wrapper = styled.div `
  position: absolute;
  top: 116px;
  left: 426px;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 198px;
`;
const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 13px;
  padding: 20px;

  border: 1px solid rgba(0, 241, 227, 1);
  border-radius: 15px;
`;
const PlayerWrapper = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
`;
const ImageContainer = styled.div `
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  box-sizing: border-box;

  background-color: rgba(255, 255, 255, 0.04);
  border: 2px solid rgba(64, 64, 64, 1);
  border-radius: 50%;
`;
const VotingPlayerAvatar = styled.img `
  position: relative;
  z-index: 2;
  display: block;
  width: 75px;
  height: 75px;
  object-fit: cover;
  object-position: center;

  border-radius: 50%;

  box-shadow: 0px 0px 10.77px 0px rgba(0, 0, 0, 0.64);
`;
const PlayerAvatar = styled.img `
  position: relative;
  z-index: 2;
  display: block;
  width: 75px;
  height: 75px;
  object-fit: cover;
  object-position: center;

  border-radius: 50%;

  box-shadow: 0px 0px 10.77px 0px rgba(0, 0, 0, 0.64);
`;
const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const Title = styled.h3 `
  margin: 0;

  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #fff;
`;
const Subtitle = styled.p `
  margin: 0;

  font-size: 14px;
  line-height: 22px;
  color: rgba(203, 203, 203, 1);
`;
const Dots = styled.img `
  position: absolute;
  left: 20px;
  top: calc(50% - (18px / 2));

  display: block;
  height: 18px;
`;
export function VoteTarget({ votingPlayer, player, onClose, vote, resetVote, onVotingStateChange }) {
    var _a, _b, _c, _d, _e;
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const currentVoteId = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.voteId) || '';
    useEffect(() => {
        if (vote && player && resetVote) {
            onVotingStateChange === null || onVotingStateChange === void 0 ? void 0 : onVotingStateChange(true);
            confirmPlayerVote(currentVoteId, player.id)
                .then((response) => {
                dispatch(setMatchState(response));
                onClose === null || onClose === void 0 ? void 0 : onClose(player);
            })
                .catch((err) => errorHandler(err))
                .finally(() => {
                onVotingStateChange === null || onVotingStateChange === void 0 ? void 0 : onVotingStateChange(false);
            });
            resetVote();
        }
    }, [vote, player, onClose, resetVote, onVotingStateChange]);
    VotingPlayerAvatar.defaultProps = {
        src: ((_b = votingPlayer === null || votingPlayer === void 0 ? void 0 : votingPlayer.player) === null || _b === void 0 ? void 0 : _b.photoUrl)
            ? (_c = votingPlayer === null || votingPlayer === void 0 ? void 0 : votingPlayer.player) === null || _c === void 0 ? void 0 : _c.photoUrl
            : (votingPlayer === null || votingPlayer === void 0 ? void 0 : votingPlayer.player.gender) === "MALE"
                ? maleAvatar
                : femaleAvatar,
    };
    PlayerAvatar.defaultProps = {
        src: ((_d = player === null || player === void 0 ? void 0 : player.player) === null || _d === void 0 ? void 0 : _d.photoUrl)
            ? (_e = player === null || player === void 0 ? void 0 : player.player) === null || _e === void 0 ? void 0 : _e.photoUrl
            : (player === null || player === void 0 ? void 0 : player.player.gender) === "MALE"
                ? maleAvatar
                : femaleAvatar,
    };
    Dots.defaultProps = {
        src: dots,
    };
    return votingPlayer ? (_jsx(Wrapper, { children: _jsxs(ContentWrapper, { children: [_jsxs(PlayerWrapper, { children: [_jsx(ImageContainer, { children: _jsx(VotingPlayerAvatar, {}) }), _jsxs(TextContainer, { children: [_jsx(Title, { children: votingPlayer === null || votingPlayer === void 0 ? void 0 : votingPlayer.player.gameName }), _jsx(Subtitle, { children: "\u041E\u0442\u0434\u0430\u0435\u0442 \u0441\u0432\u043E\u0439 \u0433\u043E\u043B\u043E\u0441" })] })] }), player && player !== votingPlayer && (_jsxs(_Fragment, { children: [_jsx(Dots, {}), _jsxs(PlayerWrapper, { children: [_jsx(ImageContainer, { children: _jsx(PlayerAvatar, {}) }), _jsxs(TextContainer, { children: [_jsx(Title, { children: player === null || player === void 0 ? void 0 : player.player.gameName }), _jsx(Subtitle, { children: "\u041D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u043F\u043E\u0434 \u043F\u0440\u0438\u0446\u0435\u043B\u043E\u043C" })] })] })] }))] }) })) : null;
}
